var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "项目充值记录确认",
        visible: _vm.dialogVisible,
        width: "960px",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleCancel,
      },
    },
    [
      _c("div", { staticClass: "project-record-title" }, [
        _vm._v(
          "\n    当前项目编号：" +
            _vm._s(_vm.projectNumber) +
            " " +
            _vm._s(
              _vm.recordList.length ? "已有充值(回收)记录" : "暂无充值记录"
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.recordList,
            border: "",
            size: "mini",
            "max-height": "320",
            "empty-text": "暂无充值记录",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "projectNumber",
              label: "项目编号",
              "min-width": "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "类型", "min-width": "90" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      { class: ["record-type", _vm.getTypeClass(scope.row)] },
                      [_vm._v(_vm._s(scope.row.typeName))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态", "min-width": "90" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      { class: _vm.getStatusClass(scope.row.status) },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getStatusName(scope.row.status)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "auditStatus",
              label: "审核状态",
              "min-width": "90",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      { class: _vm.getAuditStatusClass(scope.row.auditStatus) },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getAuditStatusName(scope.row.auditStatus)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "reason",
              label: "发放原因",
              "min-width": "130",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "companyName",
              label: "发放公司",
              "min-width": "180",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "relationCount",
              label: "关联人数",
              "min-width": "90",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "operateTime",
              label: "操作时间",
              "min-width": "160",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "operatorName",
              label: "操作人",
              "min-width": "100",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.loading,
                disabled: _vm.loading,
              },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("\n      确认继续发放\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }